import { render, staticRenderFns } from "./ReferDoctor.vue?vue&type=template&id=40aaa058"
import script from "./ReferDoctor.vue?vue&type=script&lang=js"
export * from "./ReferDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports